// Holistic Functional Profile — non-diagnostic disclaimer and usage guidance
// for the clinician-facing HFP card.
//
// The two statements are the wording agreed on the 6 Aug 2026 BTH review call
// (dictated by the clinical lead while reviewing the HFP card): the profile is
// an organisational aid based on the WHO International Classification of
// Functioning, Disability and Health — it is not a validated diagnostic tool
// and must not dictate clinical judgement. Any change to this copy crosses the
// clinical correctness gate and the comprehension gate before release.

export const HFP_CARD_DISCLAIMER_SUMMARY =
  'Not a diagnosis: this profile organises information and must not dictate '
  + 'clinical judgement.';

export const HFP_NON_DIAGNOSTIC_STATEMENT =
  'This profile represents the full range of function of a young person. '
  + 'Neurodevelopment includes a variety of areas of difficulty, need or '
  + 'diagnosis — medical, educational or otherwise — and these items do not '
  + 'necessarily equate to or indicate a specific medical diagnosis.';

export const HFP_NO_SCORING_STATEMENT =
  'This profile describes the many areas of function of a young person. There '
  + 'is no scoring system or validation behind it, so the number of priority '
  + 'or support-need areas will not necessarily equate to any further action '
  + 'through this tool or through any diagnostic pathway.';

export const HFP_USAGE_GUIDANCE = [
  'Use it to organise information and priorities from the referral.',
  'It is based on the WHO International Classification of Functioning, '
  + 'Disability and Health.',
  'It never replaces your own assessment of the evidence.',
];
